import React, { useState } from "react";
import {
    Container,
    Card,
    Table,
    Button,
    Pagination,
    Form,
    InputGroup,
} from "react-bootstrap";

import { Link } from "react-router-dom";

export default function FundRequestView() {

    const fundRequestView = [
        {
            id: 1,
            userId: "USR1001",
            name: "Arun Kumar",
            amount: "₹500",
            receipt: "receipt1.jpg",
            txnId: "TXN784512",
            date: "2026-06-01",
        },
        {
            id: 2,
            userId: "USR1002",
            name: "Rahul",
            amount: "₹1000",
            receipt: "receipt2.jpg",
            txnId: "TXN784513",
            date: "2026-06-01",
        },
        {
            id: 3,
            userId: "USR1003",
            name: "Vijay",
            amount: "₹2000",
            receipt: "receipt3.jpg",
            txnId: "TXN784514",
            date: "2026-06-02",
        },
        {
            id: 4,
            userId: "USR1004",
            name: "Karthik",
            amount: "₹1500",
            receipt: "receipt4.jpg",
            txnId: "TXN784515",
            date: "2026-06-02",
        },
        {
            id: 5,
            userId: "USR1005",
            name: "Praveen",
            amount: "₹3000",
            receipt: "receipt5.jpg",
            txnId: "TXN784516",
            date: "2026-06-03",
        },
        {
            id: 6,
            userId: "USR1006",
            name: "Suresh",
            amount: "₹800",
            receipt: "receipt6.jpg",
            txnId: "TXN784517",
            date: "2026-06-03",
        },
        {
            id: 7,
            userId: "USR1007",
            name: "Deepak",
            amount: "₹2500",
            receipt: "receipt7.jpg",
            txnId: "TXN784518",
            date: "2026-06-04",
        },
        {
            id: 8,
            userId: "USR1008",
            name: "Harish",
            amount: "₹1200",
            receipt: "receipt8.jpg",
            txnId: "TXN784519",
            date: "2026-06-04",
        },
        {
            id: 9,
            userId: "USR1009",
            name: "Manoj",
            amount: "₹700",
            receipt: "receipt9.jpg",
            txnId: "TXN784520",
            date: "2026-06-05",
        },
        {
            id: 10,
            userId: "USR1010",
            name: "Ramesh",
            amount: "₹5000",
            receipt: "receipt10.jpg",
            txnId: "TXN784521",
            date: "2026-06-05",
        },
    ];

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const rowsPerPage = 5;

    // Filter by search
    const filteredUsers = fundRequestView.filter(
        (user) =>
            user.name.toLowerCase().includes(search.toLowerCase()) ||
            user.userId.includes(search) ||
            user.mobile.includes(search)
    );

    const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);


    const paginatedUsers = filteredUsers.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const buildPages = () =>
        Array.from({ length: totalPages }, (_, i) => i + 1);


    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    return (
        <>

            <div className="breadcrumb-bar mb-2 mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                            // onClick={() => navigate("/admin/projectlist")}
                            >
                                Fund request
                            </span>

                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >

                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>


            <div className="awd-page">
                <Container fluid>


                    <div className="awd-header">
                        <div>
                            <h2 className="awd-main-title d-flex flex-row ">
                                View Fund Request
                                <div className="awd-total-badge d-flex align-items-center justify-content-center mx-2 my-2">
                                    {/* <span>Total</span> */}

                                    <span className="awd-total-count">
                                        {filteredUsers.length}
                                    </span>
                                </div>
                            </h2>
                        </div>
                    </div>

                    {/* Filter Bar */}

                    <Card className="awd-filter-card">
                        <div className="awd-filter-wrap">
                            <div className="awd-export-buttons">
                                <Button className="awd-export-btn">
                                    <i className="bi bi-files"></i>
                                    Copy
                                </Button>

                                <Button className="awd-export-btn">
                                    CSV
                                </Button>

                                <Button className="awd-export-btn">
                                    Excel
                                </Button>

                                <Button className="awd-export-btn">
                                    PDF
                                </Button>

                                <Button className="awd-export-btn">
                                    Print
                                </Button>
                            </div>



                            <div className="awd-filter-right">

                                <InputGroup className="awd-search-box">
                                    <InputGroup.Text>
                                        <i className="bi bi-search"></i>
                                    </InputGroup.Text>

                                    <Form.Control
                                        placeholder="Search Members..."
                                        value={search}
                                        onChange={handleSearch}
                                    />
                                </InputGroup>
                            </div>

                        </div>
                    </Card>

                    {/* Total Count Row */}


                    {/* Table */}

                    <Card className="ud-table-card">
                        <Card.Body className="p-0">
                            <div className="ud-scroll-wrap">
                                <Table
                                    hover
                                    borderless
                                    className="ud-table align-middle mb-0"
                                >
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>User Id</th>
                                            <th>Name</th>
                                            <th>Amount</th>
                                            <th>Receipt</th>
                                            <th>Txn Id</th>
                                            <th>Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedUsers.map((user) => (
                                            <tr key={user.id}>

                                                <td>{user.id}</td>

                                                <td>
                                                    <span className="awd-userid">
                                                        {user.userId}
                                                    </span>
                                                </td>

                                                <td>
                                                    <div className="ud-user-cell">

                                                        {/* <span className="ud-avatar">
                                                            {user.name
                                                                .split(" ")
                                                                .map((n) => n[0])
                                                                .join("")
                                                                .substring(0, 2)}
                                                        </span> */}

                                                        <span className="ud-user-name">
                                                            {user.name}
                                                        </span>

                                                    </div>
                                                </td>

                                                <td>
                                                    <span
                                                        style={{
                                                            fontWeight: 600,
                                                            color: "#00a8d6",
                                                        }}
                                                    >
                                                        {user.amount}
                                                    </span>
                                                </td>

                                                <td>
                                                    <Button
                                                        size="sm"
                                                        className="global-login-btn"
                                                    >
                                                        View
                                                    </Button>
                                                </td>

                                                <td>{user.txnId}</td>

                                                <td>{user.date}</td>

                                                <td className="d-flex justify-content-center align-items-center">
                                                    <Button
                                                        size="sm"
                                                        className="global-login-btn"
                                                    >
                                                        Approve
                                                    </Button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Pagination */}

                    <div className="ud-pagination-wrap">
                        <Pagination className="ud-pagination mb-0">
                            <Pagination.Prev
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            />

                            {buildPages().map((p) => (
                                <Pagination.Item
                                    key={p}
                                    active={page === p}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            />
                        </Pagination>
                    </div>
                </Container>
            </div>
        </>
    );
}